"use client";

import { TabBar } from "@/components/tab-bar";
import { Content } from "@/services/content/types";
import { useState } from "react";
import ItemFeed from "./item-feed";

type Tab = "artiklar" | "kommentarer" | "analyser";

type Props = {
  companyName?: string;
  articles: Content.Article[];
  comments: Content.Article[];
  analyses: Content.Article[];
  hasComments: boolean;
  hasAnalyses: boolean;
  loadMoreArticles: (page: number) => Promise<any>;
  loadMoreComments: (page: number) => Promise<any>;
  loadMoreAnalyses: (page: number) => Promise<any>;
};

const TAB_LABELS: Record<Tab, string> = {
  artiklar: "Artiklar",
  kommentarer: "Kommentarer",
  analyser: "Analyser",
};

const InstrumentNewsTabs = ({
  companyName,
  articles,
  comments,
  analyses,
  hasComments,
  hasAnalyses,
  loadMoreArticles,
  loadMoreComments,
  loadMoreAnalyses,
}: Props) => {
  const [activeTab, setActiveTab] = useState<Tab>("artiklar");

  const visibleTabs: Tab[] = ["artiklar"];
  if (hasComments) visibleTabs.push("kommentarer");
  if (hasAnalyses) visibleTabs.push("analyser");

  const activeItems =
    activeTab === "kommentarer" ? comments
    : activeTab === "analyser" ? analyses
    : articles;

  const activeLoadMore =
    activeTab === "kommentarer" ? loadMoreComments
    : activeTab === "analyser" ? loadMoreAnalyses
    : loadMoreArticles;

  if (articles.length === 0 && !hasComments && !hasAnalyses) return null;

  return (
    <div className="container mb-16 border-b border-sand-700">
      <div className="font-bold text-xl mb-2">
        {companyName ? `Senaste artiklarna om ${companyName}` : "Senaste nytt"}
      </div>

      {visibleTabs.length > 1 && (
        <TabBar
          tabs={visibleTabs.map((t) => ({ label: TAB_LABELS[t], value: t }))}
          active={activeTab}
          onChange={setActiveTab}
        />
      )}

      <ItemFeed
        key={activeTab}
        items={activeItems}
        initialPage={1}
        loadMore={activeLoadMore}
      />
    </div>
  );
};

export default InstrumentNewsTabs;
